module.exports = __webpack_public_path__ + "static/img/103894.3a93c7c0.png";